import gql from 'graphql-tag';
export const rugbyUnionStatFragment = gql `
  fragment UnionStats on RugbyUnionStats {
    tries
    tryAssists
    conversions
    conversionsMissed
    penaltyGoals
    penaltyGoalsMissed
    penaltyTries
    dropGoals
    dropGoalsMissed
    redCards
    yellowCards
    penaltiesConceded
    kickCompGoals
    kickCompGoalsMissed
    turnoversConceded
    scrums
    scrumsConceded
    lineouts
    lineoutsConceded
    rucks
    rucksConceded
    restarts
    freeKicks
    kicks
    cleanBreaks
    defenderBeatens
    substitutions
    possession
  }
`;
//# sourceMappingURL=RugbyUnionStats.js.map